<template>
  <div class="ui form" ref="form">
    <div class="ui pointing secondary menu">
      <a class="item active" data-tab="general">
        <i class="info icon"></i>
        {{ $t("general") }}
      </a>
      <a class="item" data-tab="testing">
        <i class="lightning icon"></i>
        {{ $t("test") }}
      </a>
      <a class="item" data-tab="listeners">
        <i class="code icon"></i>
        {{ $t("listeners") }}
      </a>
      <a class="item" data-tab="notifications">
        <i class="alert sign icon"></i>
        {{ $t("notifications") }}
      </a>
    </div>
    <div class="ui bottom attached tab general segment active" data-tab="general">
      <div class="fields">
        <div class="ten column wide field">
          <label for>{{ $t("database") }}</label>
          <div class="ui selection dropdown" ref="database">
            <input type="hidden" name="database" />
            <i class="dropdown icon"></i>
            <div class="default text"></div>
            <div class="menu"></div>
          </div>
        </div>
        <div class="six column wide field">
          <label for>{{ $t("execute at") }}</label>
          <select
            class="ui selection dropdown"
            name="execute_at"
            v-model="setup.execute_at"
            ref="execute_at"
          >
            <option value="start">{{ $t("start") }}</option>
            <option value="end">{{ $t("end") }}</option>
          </select>
        </div>
      </div>
      <div class="field">
        <label for>{{ $t("command") }}</label>
        <editor @init="init_command" v-model="setup.command" lang="sql" theme="monokai"></editor>
      </div>
      <h4 class="ui dividing header">{{ $t("arguments") }}</h4>
      <div class="ui grid">
        <div class="eight wide column" v-for="(arg, idx) in setup.arguments" :key="idx">
          <div class="field">
            <label for>{{ arg.name }}</label>
            <div class="ui left icon input">
              <input type="text" v-model="setup.arguments[idx].value" />
              <i class="keyboard icon"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ui bottom attached tab segment" data-tab="testing">
      <h4 class="ui dividing header">{{ $t("arguments") }}</h4>
      <div class="ui grid">
        <div class="eight wide column" v-for="(arg, idx) in test_arguments" :key="idx">
          <div class="field">
            <label for>{{ arg.name }}</label>
            <div class="ui left icon input">
              <input type="text" v-model="test_arguments[idx].value" />
              <i class="keyboard icon"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ui bottom attached tab segment" data-tab="listeners">
      <div class="ui info message" style="display: block">
        <div class="header">{{ $t("hints") }}</div>
        <ul class="list">
          <li v-html="$t('use D to refer data objects')"></li>
        </ul>
      </div>
      <div class="field">
        <label for>{{ $t("on execute") }}</label>
        <editor
          @init="init_editor"
          @
          v-model="setup.listeners.on_execute"
          lang="javascript"
          theme="monokai"
          ref="command_editor"
        ></editor>
      </div>
    </div>
    <div class="ui bottom attached tab segment" data-tab="notifications">
      <notifications-manager :events="events" :notifications="setup.notifications" />
    </div>
    <button class="ui green labeled icon fluid button" type="button" @click="ok">
      <i class="ui check icon"></i>
      {{ $t("ok") }}
    </button>
    <div class="ui error message"></div>
  </div>
</template>

<script>
import Editor from "vue2-ace-editor";
import NotificationsManager from "../NotificationsManager";
import { clone } from "@/utils";
import { isEmpty } from "lodash";

export default {
  name: "EscalationBoundaryEventSidebar",
  components: {
    Editor,
    NotificationsManager
  },
  data() {
    return {
      setup: {
        name: "",
        database: "",
        command: "",
        execute_at: "start",
        listeners: {
          on_execute: ""
        },
        notifications: [],
        arguments: []
      },
      events: [{ display: this.$t("expire"), value: "expire" }],
      form: {},
      test_arguments: []
    };
  },
  props: {
    process: Object,
    element: Object,
    project: Object,
    databases: Array,
    datasources: Array
  },
  mounted() {
    let vm = this;
    window
      .jQuery(vm.$el)
      .find(".pointing.menu .item")
      .tab();

    vm.form = window.jQuery(vm.$refs.form).form({
      fields: {
        name: ["empty"],
        execute_at: ["empty"],
        database: ["empty"]
      }
    });

    if (vm.databases.length) {
      let vls = vm.databases.map(d => {
        return {
          name: `${d.database} | ${d.engine}`,
          icon: "database",
          value: d.uuid
        };
      });
      window
        .jQuery(vm.$refs.database)
        .dropdown("setup menu", { values: vls })
        .dropdown({
          onChange(value) {
            vm.setup.database = value;
          }
        });
    }

    window.jQuery("select.selection.dropdown").dropdown();

    // vm.$refs.command_editor.editor.session.on("change", function(delta) {
    //   console.log(delta);

    // });

    let conf = vm.$props.element.ngine_configuration;
    if (!isEmpty(conf)) {
      vm.setup = clone(conf);
      vm.test_arguments = clone(conf.arguments);

      window.jQuery(vm.$refs.database).dropdown("set selected", conf.database);
      window
        .jQuery(vm.$refs.execute_at)
        .dropdown("set selected", conf.execute_at);
    }
  },
  methods: {
    ok() {
      let isValid = this.form.form("validate form");
      if (isValid) {
        this.$emit("ok", this.setup);
      }
    },
    cancel() {
      this.$emit("cancel");
    },
    init_editor() {
      require("brace/mode/javascript");
      require("brace/theme/monokai");
    },
    init_command() {
      require("brace/mode/sql");
      require("brace/theme/monokai");
    }
  },
  computed: {},
  watch: {
    "setup.command": function() {
      var vCode = this.setup.command;
      let _params = vCode.match(/:[a-zA-Z_][a-zA-Z_0-9]*/gi);
      if (_params) {
        let _mappedParams = _params.map(elmnt => {
          return {
            name: elmnt,
            value: undefined
          };
        });
        this.setup.arguments = _mappedParams;
        this.test_arguments = clone(_mappedParams);
      }
    }
  }
};
</script>
